import SimpleStatsCard from '@features/analytics/SimpleStatsCard';

const NumRentalsCard = () => {
  return <SimpleStatsCard label="Rentals" val={24} />;
};

export default NumRentalsCard;
